import _ from 'underscore';
import Backbone from 'backbone';
import Editor from '@bingads-webui-campaign-legacy/crud-ad/view/adEditor';
import template from '../template/editors-container.pug';
import AdgroupEditor from './adgroup-editor';

export default class EditorsContainer extends Backbone.View {
  initialize({
    deps,
    i18n,
    searchExamples,
    model,
    campaignId,
    adGroupId,
  }) {
    this.i18n = i18n;
    this.deps = deps;
    this.model = model;
    this.searchExamples = searchExamples;

    this.campaignEditor = new deps.CampaignEditor({
      ...model,
    });

    this.adgroupEditor = new AdgroupEditor({
      i18n,
      SearchBidView: deps.SearchBidView,
      BiddingStrategyView: deps.BiddingStrategyView,
      model: this.model,
    });

    const AdsEditor = Editor;
    this.adEditor = new AdsEditor({
      model,
      campaignId,
      adGroupId,
      isSaveToServer: false,
      showInline: true,
    });

    // Bind DomainName in campaignEditor to DisplayUrl in adEditor
    if (this.campaignEditor.dsaSettingsView) {
      this.campaignEditor.dsaSettingsView.viewModel.DomainName.subscribe((newDomain) => {
        this.model.DisplayUrl(newDomain);
      });
    }
  }

  hasChanged() {
    const type = this.adEditor.viewModel.Type();
    const params = this.adEditor.adTypeViews[type].toObject();
    return this.adEditor.hasChange(params, type);
  }

  render() {
    const examplesLength = this.searchExamples.length;
    this.$el.empty().append(template({ i18n: this.i18n, examplesLength }));
    _.each(this.searchExamples, (example, index) => {
      this.$('.preview-search-examples').append(`<div>${example + (index === examplesLength - 1 ? '' : ',')}</div>`);
    });

    this.$('.campaignEditor-container').prepend(this.campaignEditor.render().el);
    this.campaignEditor.willShow();

    // Take out budget input and input error
    this.$('.budget').before(this.$('.container-budget > div:nth-child(1)'));
    this.$('.container-budget > div:nth-child(1)').addClass('col-sm-6').removeClass('col-sm-12');
    this.$('.budget').before(this.$('.container-budget > div:nth-child(1)'));
    // Disable fields not needed in campaignEditor
    this.$('.copy-campaign-settings').remove();
    this.$('#CampaignSettings_AdvancedBudgetOptions_Label').remove();
    this.$('.dsa-targeting-source').parent().remove();
    this.$('.language-container').remove();

    this.$('.adgroupEditor-container').prepend(this.adgroupEditor.render().el);

    // Disable fields not needed in adsEditor
    this.$('.adEditor-container').prepend(this.adEditor.render().el);
    this.$('.advanced-options').remove();

    // Set elements for example searches and ads preview
    this.$('.adEditor-container .col-sm-6').get(2).classList.add('preview-ads');
    this.$('.alert-info.form-group').before(this.$('.search-examples-container'));
    this.$('.preview-container').before(this.$('.ads-preview-label'));
    // fix this css due to set h5 to h2 to meet a11y requirements.
    this.$('.campaignEditor-container h2.control-label').css('margin-top', '10.5px');
    this.$('.adgroupEditor-container h2.control-label').css('margin-top', '10.5px');

    return this;
  }

  dealWithInlineError(errors) {
    this.campaignEditor.getAndHandleApiErrors(errors);
    this.campaignEditor.scrollToErrors();
  }

  getModel() {
    return _.extend(
      {},
      this.campaignEditor.getData(),
      this.adgroupEditor.getAdGroup(),
      this.adEditor.adTypeViews.DynamicSearch.toObject()
    );
  }

  validate() {
    return _.every([
      this.campaignEditor.validate(),
      this.adgroupEditor.validate(),
      this.adEditor.validate('DynamicSearch'),
    ]);
  }

  get template() { return template; }
}
